import { render, staticRenderFns } from "./SaleUsedCar.vue?vue&type=template&id=06f6d965&scoped=true&"
import script from "./SaleUsedCar.vue?vue&type=script&lang=js&"
export * from "./SaleUsedCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6d965",
  null
  
)

export default component.exports